import React from "react"
import styled from "styled-components"

const TheEbSection = styled.section`
  display: flex;
  justify-content: center;
  padding-top: 58px;
  padding-bottom: 80px;
  box-sizing: border-box;
`

const CheatWrapper = styled.div`
  padding: 0 150px;
  width: 100%;
  @media only screen and (max-width: 1100px) {
    padding: 0 120px;
  }
  @media only screen and (max-width: 1000px) {
    padding: 0 64px;
  }
  @media only screen and (max-width: 700px) {
    padding: 0 64px;
  }
  @media only screen and (max-width: 600px) {
    padding: 0 48px;
  }
  @media only screen and (max-width: 500px) {
    padding: 0 36px;
  }
  @media only screen and (max-width: 400px) {
    padding: 0 24px;
  }
`

const Main = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  @media only screen and (max-width: 900px) {
    flex-direction: column;
  }
`
const EBIntroWrapper = styled.div`
  width: 40%;
  margin: 36px 0 0;
  h2 {
    padding-left: 4px;
    font-family: "Tinos", serif;
    font-style: italic;
    font-weight: bold;
    font-size: 22px;
    line-height: 25px;
    color: #989085;
    align-self: start;
  }
  h3 {
    font-family: "Amasis", serif;
    font-style: normal;
    font-weight: bold;
    font-size: 26px;
    line-height: 33px;
    color: #3e3120;
  }
  p {
    margin: 12px 0 16px 0;
    font-family: "Cabin", Sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 170%;
    color: #424242;
  }
  @media only screen and (max-width: 1300px) {
    width: 35%;
    h2 {
      font-size: 20px;
    }
    h3 {
      font-size: 24px;
    }
    p {
      font-size: 14px;
    }
  }
  @media only screen and (max-width: 1150px) {
    h2 {
      font-size: 18px;
    }
    h3 {
      font-size: 22px;
    }
    p {
      font-size: 13px;
    }
  }
  @media only screen and (max-width: 900px) {
    width: 100%;
  }
  @media only screen and (max-width: 600px) {
    h2 {
      font-size: 17px;
    }
    h3 {
      font-size: 21px;
    }
    p {
      font-size: 12px;
    }
  }
`

const EBBoxWrapper = styled.div`
  width: 60%;
  margin-left: 20px;
  background: #fffefd;
  border: 1px solid #461459;
  box-sizing: border-box;
  box-shadow: 4px 4px 0px #310542;
  padding: 40px 24px;
  @media only screen and (max-width: 1300px) {
    width: 65%;
  }
  @media only screen and (max-width: 900px) {
    width: 100%;
    margin: 0;
  }
  @media only screen and (max-width: 500px) {
    overflow-x: scroll;
  }
`

const EBBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  > div {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  > div .name {
    font-family: "Amasis", serif;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 23px;
    color: #3e3120;
    margin-bottom: 5px;
  }
  > div .position {
    font-family: "Amasis", serif;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 23px;
    color: #c6bcaf;
    margin-bottom: 5px;
  }
  .course {
    color: #989085;
    font-family: "Tinos", serif;
    font-style: italic;
    font-weight: 700;
    font-size: 10px;
    line-height: 142.99%;
  }
  margin-bottom: 16px;

  @media only screen and (max-width: 1150px) {
    div .name,
    div .position {
      font-size: 14px;
    }
  }
  @media only screen and (max-width: 900px) {
    div .name,
    div .position {
      font-size: 16px;
    }
  }
  @media only screen and (max-width: 670px) {
    div .name,
    div .position {
      font-size: 14px;
    }
  }
  @media only screen and (max-width: 570px) {
    div .name,
    div .position {
      font-size: 12px;
    }
  }
  @media only screen and (max-width: 500px) {
    width: 500px;
    padding: 0 32px 0 0;
  }
`

// const

const TheEB: React.FC<{
  editorInChiefName: string
  editorInChiefCourse: string
  associateEditorName: string
  associateEditorCourse: string
  managingEditorForFinanceName: string
  managingEditorForFinanceCourse: string
  managingDirectorForExternalAffairsName: string
  managingDirectorForExternalAffairsCourse: string
  managingEditorForInternalAffairsName: string
  managingEditorForInternalAffairsCourse: string
  artEditorName: string
  artEditorCourse: string
  associateArtEditorName: string
  associateArtEditorCourse: string
  englishEditorName: string
  englishEditorCourse: string
  associateEnglishEditorName: string
  associateEnglishEditorCourse: string
  heightsOnlineEditorName: string
  heightsOnlineEditorCourse: string
  heightsAssociateOnlineEditorName: string
  heightsAssociateOnlineEditorCourse: string
  designEditorName: string
  designEditorCourse: string
  associateDesignEditorName: string
  associateDesignEditorCourse: string
  patnugotNgBagwisangFilipinoName: string
  patnugotNgBagwisangFilipinoCourse: string
  productionManagerName: string
  productionManagerCourse: string
  katuwangNaPatnugotNgBagwisangFilipinoName: string
  katuwangNaPatnugotNgBagwisangFilipinoCourse: string
  associateProductionManagerName: string
  associateProductionManagerCourse: string
}> = function ({
  editorInChiefName,
  editorInChiefCourse,
  associateEditorName,
  associateEditorCourse,
  managingEditorForFinanceName,
  managingEditorForFinanceCourse,
  managingDirectorForExternalAffairsName,
  managingDirectorForExternalAffairsCourse,
  managingEditorForInternalAffairsName,
  managingEditorForInternalAffairsCourse,
  artEditorName,
  artEditorCourse,
  associateArtEditorName,
  associateArtEditorCourse,
  englishEditorName,
  englishEditorCourse,
  associateEnglishEditorName,
  associateEnglishEditorCourse,
  heightsOnlineEditorName,
  heightsOnlineEditorCourse,
  heightsAssociateOnlineEditorName,
  heightsAssociateOnlineEditorCourse,
  designEditorName,
  designEditorCourse,
  associateDesignEditorName,
  associateDesignEditorCourse,
  patnugotNgBagwisangFilipinoName,
  patnugotNgBagwisangFilipinoCourse,
  productionManagerName,
  productionManagerCourse,
  katuwangNaPatnugotNgBagwisangFilipinoName,
  katuwangNaPatnugotNgBagwisangFilipinoCourse,
  associateProductionManagerName,
  associateProductionManagerCourse,
}) {

  return (
    <TheEbSection>
      <CheatWrapper>
        <Main>
          <EBIntroWrapper>
            <h2>Editorial Board A.Y. 2020-2021</h2>
            <h3 className="headline">
              The Team behind the success of HEIGHTS Ateneo Today
            </h3>
            <p className="description">
              The Heights Editorial Board is composed of student leaders who
              ascertain that literary and artistic excellence thrives in the
              Ateneo community. It has three main branches, namely, the
              executive editors, the delibrations editors, and the
              organizational editors.
            </p>
          </EBIntroWrapper>
          <EBBoxWrapper>
            <EBBox>
              <div>
                <h2 className="name">{editorInChiefName}</h2>
                {/* <h2 className="position">.....</h2> */}
                <h2 className="position">Editor-in-Chief</h2>
              </div>
              <h3 className="course">{editorInChiefCourse}</h3>
            </EBBox>
            <EBBox>
              <div>
                <h2 className="name">{associateEditorName}</h2>
                {/* <h2 className="position">.....</h2> */}
                <h2 className="position">Associate Editor</h2>
              </div>
              <h3 className="course">{associateEditorCourse}</h3>
            </EBBox>
            <EBBox>
              <div>
                <h2 className="name">
                  {managingDirectorForExternalAffairsName}
                </h2>
                {/* <h2 className="position">.....</h2> */}
                <h2 className="position">
                  Managing Editor for External Affairs
                </h2>
              </div>
              <h3 className="course">
                {managingDirectorForExternalAffairsCourse}
              </h3>
            </EBBox>
            <EBBox>
              <div>
                <h2 className="name">{managingEditorForInternalAffairsName}</h2>
                {/* <h2 className="position">.....</h2> */}
                <h2 className="position">
                  Managing Editor for Internal Affairs
                </h2>
              </div>
              <h3 className="course">
                {managingEditorForInternalAffairsCourse}
              </h3>
            </EBBox>
            <EBBox>
              <div>
                <h2 className="name">{managingEditorForFinanceName}</h2>
                {/* <h2 className="position">.....</h2> */}
                <h2 className="position">Managing Editor for Finance</h2>
              </div>
              <h3 className="course">{managingEditorForFinanceCourse}</h3>
            </EBBox>
            <EBBox>
              <div>
                <h2 className="name">{artEditorName}</h2>
                {/* <h2 className="position">.....</h2> */}
                <h2 className="position">Art Editor</h2>
              </div>
              <h3 className="course">{artEditorCourse}</h3>
            </EBBox>
            <EBBox>
              <div>
                <h2 className="name">{associateArtEditorName}</h2>
                {/* <h2 className="position">.....</h2> */}
                <h2 className="position">Associate Art Editor</h2>
              </div>
              <h3 className="course">{associateArtEditorCourse}</h3>
            </EBBox>
            <EBBox>
              <div>
                <h2 className="name">{englishEditorName}</h2>
                {/* <h2 className="position">.....</h2> */}
                <h2 className="position">English Editor</h2>
              </div>
              <h3 className="course">{englishEditorCourse}</h3>
            </EBBox>
            <EBBox>
              <div>
                <h2 className="name">{associateEnglishEditorName}</h2>
                {/* <h2 className="position">.....</h2> */}
                <h2 className="position">Associate English Editor</h2>
              </div>
              <h3 className="course">{associateEnglishEditorCourse}</h3>
            </EBBox>
            <EBBox>
              <div>
                <h2 className="name">{patnugotNgBagwisangFilipinoName}</h2>
                {/* <h2 className="position">.....</h2> */}
                <h2 className="position">
                  Filipino Editor
                </h2>
              </div>
              <h3 className="course">{patnugotNgBagwisangFilipinoCourse}</h3>
            </EBBox>
            <EBBox>
              <div>
                <h2 className="name">{katuwangNaPatnugotNgBagwisangFilipinoName}</h2>
                {/* <h2 className="position">.....</h2> */}
                <h2 className="position">
                  Associate Filipino Editor
                </h2>
              </div>
              <h3 className="course">{katuwangNaPatnugotNgBagwisangFilipinoCourse}</h3>
            </EBBox>
    
            <EBBox>
              <div>
                <h2 className="name">{designEditorName}</h2>
                {/* <h2 className="position">.....</h2> */}
                <h2 className="position">
                  Design Editor
                </h2>
              </div>
              <h3 className="course">{designEditorCourse}</h3>
            </EBBox>
            <EBBox>
              <div>
                <h2 className="name">{associateDesignEditorName}</h2>
                {/* <h2 className="position">.....</h2> */}
                <h2 className="position">
                  Associate Design Editor
                </h2>
              </div>
              <h3 className="course">{associateDesignEditorCourse}</h3>
            </EBBox>
    
            <EBBox>
              <div>
                <h2 className="name">{heightsOnlineEditorName}</h2>
                {/* <h2 className="position">.....</h2> */}
                <h2 className="position">
                  HEIGHTS Online Editor
                </h2>
              </div>
              <h3 className="course">{heightsOnlineEditorCourse}</h3>
            </EBBox>
            <EBBox>
              <div>
                <h2 className="name">{heightsAssociateOnlineEditorName}</h2>
                {/* <h2 className="position">.....</h2> */}
                <h2 className="position">
                  Associate HEIGHTS Online Editor
                </h2>
              </div>
              <h3 className="course">{heightsAssociateOnlineEditorCourse}</h3>
            </EBBox>
            <EBBox>
              <div>
                <h2 className="name">{productionManagerName}</h2>
                {/* <h2 className="position">.....</h2> */}
                <h2 className="position">
                  Production Manager
                </h2>
              </div>
              <h3 className="course">{productionManagerCourse}</h3>
            </EBBox>
            <EBBox>
              <div>
                <h2 className="name">{associateProductionManagerName}</h2>
                {/* <h2 className="position">.....</h2> */}
                <h2 className="position">
                  Associate Production Manager
                </h2>
              </div>
              <h3 className="course">{associateProductionManagerCourse}</h3>
            </EBBox>
    
          </EBBoxWrapper>
        </Main>
      </CheatWrapper>
    </TheEbSection>
  )
}

export default TheEB
